import { put, takeLatest, all } from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import UomActions, { uomActionTypes } from '@Actions/uomActions';
import UomServices from '@Services/uomServices';

/**
 *
 * @param {*} action
 */
function* _createUom(action) {
  try {
    yield put(UomActions.createUomLoading(true));
    const { payload } = action;
    const newUom = yield UomServices.createUom(payload);
    if (newUom.success) {
      yield put(TrackerActions.trackAction(uomActionTypes.CREATE_UOM.SUCCESS, newUom.data));
      notification.open({
        type: 'success',
        message: 'Uom created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: newUom.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UomActions.createUomLoading(false));
  } catch (error) {
    yield put(UomActions.createUomLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(uomActionTypes.CREATE_UOM.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createUom() {
  yield takeLatest(uomActionTypes.CREATE_UOM.REQUEST, _createUom);
}

/**
 *
 * @param {*} action
 */
function* _getUoms(action) {
  try {
    yield put(UomActions.getUomsLoading(true));
    const uoms = yield UomServices.getUoms(action?.orgId, action?.page, action?.limit, action?.isActive, action?.uomName);
    yield put(UomActions.getUomsSuccess(uoms));
    yield put(UomActions.getUomsLoading(false));
  } catch (error) {
    yield put(UomActions.getUomsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(uomActionTypes.GET_UOMS.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getUoms() {
  yield takeLatest(uomActionTypes.GET_UOMS.REQUEST, _getUoms);
}

/**
 *
 * @param {*} action
 */
function* _updateUom(action) {
  try {
    yield put(UomActions.updateUomLoading(true));
    const updatedUom = yield UomServices.updateUom(action.payload);
    if (updatedUom.success) {
      yield put(TrackerActions.trackAction(uomActionTypes.UPDATE_UOM.SUCCESS, updatedUom.data));
      notification.open({
        type: 'success',
        message: 'Uom updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updatedUom.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UomActions.updateUomLoading(false));
  } catch (error) {
    yield put(UomActions.updateUomLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(uomActionTypes.UPDATE_UOM.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* updateUom() {
  yield takeLatest(uomActionTypes.UPDATE_UOM.REQUEST, _updateUom);
}

/**
 *
 */
export default function* uomSaga() {
  yield all([createUom(), getUoms(), updateUom()]);
}
